export enum ApiError {
  UNAUTHENTICATED = 'UNAUTHENTICATED',
}
